/**
 * Auto-Add Rewards System Configuration
 * 
 * This file configures the automatic gift addition system for the rewards program.
 * To use in other themes:
 * 1. Copy this file to assets/auto-add-config.js.liquid
 * 2. Copy rewards-system.js to assets/
 * 3. Add the script tags to your theme.liquid (see installation notes below)
 * 4. Configure the theme settings in config/settings_schema.json
 * 
 * Installation in theme.liquid:
 * Add before closing </head> or in the footer:
 * <script src="//www.sunyee.com.au/cdn/shop/t/111/assets/auto-add-config.js?v=154940069518730628161790956515"></script>
 * <script src="//www.sunyee.com.au/cdn/shop/t/111/assets/rewards-system.js?v=42178670022466290231756608578"></script>
 */

window.AutoAddConfig = {
  enabled: false,
  debug: false,
  products: [{
      handle: "bonus-san-hima-cob-led-head-torch-headlight-camping-rechargeable-headlamp-waterproof",
      priceThreshold: 199,
      maxQuantity: 1,
      label: "LED head torch",
      productName: "LED head torch"
    },{
      handle: "bonus-san-hima-70l-shopping-trolley-foldable-camping-cart-grocery-basket-360-wheel",
      priceThreshold: 599,
      maxQuantity: 1,
      label: "70L Shopping Trolley Foldable",
      productName: "70L Shopping Trolley Foldable"
    }].filter(product => product) // Remove any undefined products
};

// Debug logging
if (window.AutoAddConfig.debug) {
  console.log('AutoAddConfig loaded:', window.AutoAddConfig);
}